module.exports = __webpack_public_path__ + "img/alert-circle-outline.4680e2c6.svg";